import config from '../../../config';
import { getItemsWithNoJackpotCached } from '../../../utils/jackpotsV2/getItemsWithNoJackpotCached';
import { getJackpotsV2ForGames } from '../../../utils/jackpotsV2/getJackpotsV2ForGames';
import { LogicContext } from '../types';

export const getJackpotsV2ForSearchGames = async (context: LogicContext) => {
  if (config?.features?.jackpotsV2?.mode !== 'enabled') {
    return {};
  }
  const currentJackpots = context.currentJackpotsV2;
  const allGames = context.search.searchItems;
  const filteredGames = getItemsWithNoJackpotCached(allGames, currentJackpots);
  const currency = context.user?.currency || config.default_currency;
  return getJackpotsV2ForGames(filteredGames, currency);
};
